"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = Property;
exports.Virtual = Virtual;
exports.Restricted = Restricted;
const utils_1 = require("../utils");
function Property() {
    return utils_1.noop;
}
function Virtual() {
    return utils_1.noop;
}
function Restricted() {
    return utils_1.noop;
}
